import { clearNebulaToken, getNebulaToken } from './nebulaToken';

const NEBULA_API_BASE_URL = process.env.REACT_APP_NEBULA_API_BASE_URL || '';

function normalizeHeaders(headers?: HeadersInit): Record<string, string> {
  if (!headers) return {};
  if (headers instanceof Headers) {
    const result: Record<string, string> = {};
    headers.forEach((value, key) => {
      result[key] = value;
    });
    return result;
  }
  return headers as Record<string, string>;
}

async function withNebulaAuth(
  path: string,
  options: RequestInit = {},
  retryOnUnauthorized = true
): Promise<Response> {
  const token = await getNebulaToken(false);
  const existingHeaders = normalizeHeaders(options.headers);

  const response = await fetch(`${NEBULA_API_BASE_URL}${path}`, {
    ...options,
    headers: {
      ...existingHeaders,
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status === 401 && retryOnUnauthorized) {
    clearNebulaToken();
    const refreshedToken = await getNebulaToken(true);
    const retryHeaders = normalizeHeaders(options.headers);

    return fetch(`${NEBULA_API_BASE_URL}${path}`, {
      ...options,
      headers: {
        ...retryHeaders,
        Authorization: `Bearer ${refreshedToken}`,
      },
    });
  }

  return response;
}

export async function nebulaFetch(
  path: string,
  options: RequestInit = {}
): Promise<Response> {
  return withNebulaAuth(path, options);
}

export async function nebulaFetchJson<T>(
  path: string,
  options: RequestInit = {}
): Promise<T> {
  const response = await withNebulaAuth(path, options);
  const data = await response.json();
  if (!response.ok) {
    const error = new Error(data?.error || 'Nebula request failed');
    (error as any).status = response.status;
    throw error;
  }
  return data;
}
